import { createMachine } from 'xstate';
import { CompanyAdministrator, LoadingState, CompanyAdministratorsResponse } from '../../types';
import { createLoadingState } from '../../utils';
import actions from './actions';
import services from './services';

export interface Context extends LoadingState<CompanyAdministratorsResponse> {}

export const initialContext: Context = createLoadingState<CompanyAdministratorsResponse>();

export const LOAD_COMPANY_ADMINISTRATORS = 'LOAD_COMPANY_ADMINISTRATORS';

export default createMachine<Context>({
    id: 'companyAdministrators',
    initial: 'idle',
    context: { ...initialContext },
    states: {
        idle: {
            on: {
                [LOAD_COMPANY_ADMINISTRATORS]: {
                    target: 'loading',
                },
            },
        },
        loading: {
            entry: ['assignLoadingData'],
            invoke: {
                src: 'fetchCompanyAdministrators',
                onDone: {
                    target: 'loaded',
                    actions: 'assignArraySuccessData',
                },
                onError: {
                    target: 'error',
                    actions: 'assignErrorData',
                },
            },
        },
        loaded: {},
        error: {
            // entry: ['showError'],
        },
    },
}).withConfig({
    // @ts-ignore
    actions,
    // @ts-ignore
    services,
});

export const getCompanyAdministrators = (state: any): CompanyAdministrator[] =>
    state.context.data?.Results ? state.context.data?.Results : [];

export const getError = (state: any) => (state.matches('error') ? state.context.error : null);

export const getIsLoading = (state: any) => state.matches('loading');
